import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
import UnderConstruction_zn from "../container/Blank/UnderConstruction_zn";

// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Transportation = () => {
  const show = true;
  if (show) {
    return (
      <React.Fragment>
        <SEO title="交通方式 | ICSI 2022" />
        <Header />
        <Breadcrumb
          image="images/bg/banner2.jpg"
          title="交通方式"
          content="中文参会通道"
          contentTwo="交通方式"
          linkage="/"

        />

        {/* <HomeAbout /> */}
        <EmptyTwo>
          <div className="entry-content">
          <h3>西安咸阳国际机场</h3>
            <br/>

            <p>
              <img
                src="./images/xian/tr1.jpg"
                width={650}
                // height={300}
              />
            </p>
            <br/>
            <p>
            西安咸阳国际机场（IATA代码：XIY；ICAO代码：ZLXY，又称咸阳机场）位于陕西省咸阳市渭城区底张街道境内，位于西安市市中心西北方向47公里。作为关中城市群目前唯一的国际机场，机场飞行区等级为最高的4F级，具备II类盲降标准，拥有一条3000×45米、一条3800×60米跑道，三个独立运营的T1、T2、T3航站楼。咸阳国际机场是中国重要的门户机场，为西北地区最大的空中交通枢纽，也是中国大陆第7大机场（2019年客运吞吐量），同时也全国第5大机场（面积），中国西北地区最繁忙的枢纽机场。2017年西安咸阳机场旅客吞吐量4185.7万人次，位列全国第八。被Skytrax评为全球四星级机场，与北京首都、海口美兰、三亚凤凰及宜昌三峡共为现时内地综合评级最高的航空港。
            </p>

            <p>
              请访问{" "}
              <a href="http://www.xxia.com/">http://www.xxia.com/</a>以获取更多信息。
            </p>

            <p>&nbsp;</p>
            <h3>西安北站</h3>
            <br/>
            <img
              src="./images/xian/tr2.jpg"
              width={650}
              />
            <p>
              <br/>
              西安北站，又称西安北客站，是中国西安市的国家特大型铁路旅客站，建设总投资约60亿人民币，距离西安市中心12公里；距咸阳市中心21公里；距西安咸阳国际机场20公里。于2011年1月11日部分开通运营。车站原为西安局集团下辖的直属站，2020年整体建制合并至西安车站。根据西安市的城市总体规划，西安北站的规划范围33.1万平方米，为西安市的主客站，和西安站、新西安南站、新西安东站、阿房宫站一道作“三主两辅”铁路客运枢纽；在北站规划区内，将建成集铁路客运、中长途公路客运、城市轨道交通、公交车、出租汽车、社会车辆于一体的大型综合交通枢纽中心。


            </p>

            <p>&nbsp;</p>
            <h3>西安站</h3>
            <br/>
            <img
              src="./images/xian/tr3.jpg"
              width={650}
              />
            <p>
              <br/>
              西安站位于中国陕西省西安市新城区环城北路解放门外，陇海铁路1077.7公里处（站中心），并联通西康铁路、宁西铁路、包西铁路、侯西铁路、西延铁路及咸铜铁路等线路。车站始建于1934年（民国23年）12月，1935年6月启用。目前南站房于1985年启用，2021年新建北站房和高架候车室启用。车站现为中国铁路西安局集团有限公司管辖的特等站，办理客运业务，是西安铁路枢纽“四主一辅”客运系统的主站。改造后的西安站同时也是西安主城区内的大型综合交通枢纽，集高速铁路客运、普速铁路客运、中长途公路客运、城市公共交通、出租汽车、社会车辆于一体，站区南接明城墙商贸圈，北临大明宫国家遗址公园。
            </p>
          </div>
        </EmptyTwo>
        {/* <AboutFive />
				  <TestimonialContainer classOption="bg-primary-blue" />
				  <CallToActionTwo /> */}
        <Footer />
        <ScrollToTop />
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <SEO title="交通方式 | ICSI 2022" />
        <Header />
        <Breadcrumb
          image="images/bg/banner2.jpg"
          title="交通方式"
          content="中文参会通道"
          contentTwo="交通方式"
        />

        {/* <HomeAbout /> */}
        <EmptyTwo>
		<UnderConstruction_zn/>

		</EmptyTwo>
        {/* <AboutFive />
				  <TestimonialContainer classOption="bg-primary-blue" />
				  <CallToActionTwo /> */}
        <Footer />
        <ScrollToTop />
      </React.Fragment>
    );
  }
};

export default Transportation;
